import { createAction, props } from '@ngrx/store';
import { EstimatedPension } from '../models/estimated-pension.data';

export const estimatePension = createAction('[Calculator View] Estimate Pension', props<{ values: any }>());
export const estimatePensionSuccess = createAction('[Calculator View] Estimate Pension Success', props<{ data: EstimatedPension }>());
export const estimatePensionFailure = createAction('[Calculator View] Estimate Pension Failure', props<{ error: any }>());